import { api as base } from "../../lib/api";

const pref = () => {
  const b = String(base.defaults?.baseURL || "");
  return b.replace(/\/$/, "").endsWith("/api")
    ? "/comprovantes" : "/api/comprovantes";
};

const api = {
  get: (u, c) => base.get(pref() + u, c),
  post: (u, d, c) => base.post(pref() + u, d, c),
};

export const erroMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (d) return typeof d === "string" ? d : JSON.stringify(d);
  return e?.message || "Erro inesperado";
};

export default api;
